import getChartType from "../../utils/helpers/getChartType";
import { useState, useEffect } from 'react';

export function useChart(config, data) {
  const [chart, setChart] = useState(null);

  useEffect(() => {
    if (!config?.chart || !data ) return;
    const loadChart = async () => {
      const returnChart = await getChartType({
        chartInfo: [{ TYPE: config.chart.type }],
        data,
        xKey: config.chart.xKey,
        yKey: config.chart.yKey,
        valueKey: config.chart.valueKey,
        xOrder: config.chart.xOrder, 
      });
      setChart(returnChart);
    };
    loadChart();
  }, [data]);

  return chart;
}
